import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import {
    PChipGroupModule,
    PFieldModule,
    PMultipleProgressBarModule,
    PSlideToggleModule,
    PStatusSubLabelModule
} from '@frontend-site/ui/components';
import { TranslateModule } from '@ngx-translate/core';
import { PActionButtonModule } from '@panaya/ui/p-action-button';
import { PIconModule } from '@panaya/ui/p-icon';
import { PLinkModule } from '@panaya/ui/p-link';
import { PTooltipModule } from '@panaya/ui/p-tooltip';
import { PipeModule } from '@panaya/ui/pipes';
import { ColumnsPickerComponent } from './components/columns-picker';
import { PCustomDateFilterComponent } from './filters';
import {
    AddEllipsisDirective,
    BooleanIconRendererComponent,
    ClickableRendererComponent,
    FullWidthCellRendererComponent,
    GridTooltipComponent,
    GroupRowRendererComponent,
    IconTextEditorRendererComponent,
    IconTextRendererComponent,
    LinkableIconRendererComponent,
    LinkableRendererComponent,
    LinkDialogRendererComponent,
    MultipleProgressBarRendererComponent,
    PasswordCellEditorComponent,
    PenIconCellRendererComponent,
    RoutingLinkRendererComponent,
    SlideToggleRendererComponent,
    StatusRendererComponent,
    StatusSubLabelRendererComponent,
    UserRendererComponent
} from './renderers';
import { UrlsListRendererComponent } from './renderers/urls-list-renderer/urls-list-renderer.component';
import { ValueGetterRendererComponent } from './renderers/value-getter-renderer/value-getter-renderer.component';
import { DependenciesRendererComponent } from './renderers/dependencies-renderer/dependencies-renderer.component';
import { NgLetModule } from 'ng-let';
import { SelectRowHeightButtonComponent } from './select-row-height/select-row-height-button.component';
import { DynamicPFieldCellEditorComponent } from './cell-editors/dynamic-p-field-cell-editor.component';

@NgModule({
    declarations: [
        GroupRowRendererComponent,
        PCustomDateFilterComponent,
        StatusSubLabelRendererComponent,
        BooleanIconRendererComponent,
        LinkableIconRendererComponent,
        LinkableRendererComponent,
        MultipleProgressBarRendererComponent,
        UrlsListRendererComponent,
        StatusRendererComponent,
        ColumnsPickerComponent,
        IconTextRendererComponent,
        IconTextEditorRendererComponent,
        FullWidthCellRendererComponent,
        RoutingLinkRendererComponent,
        GridTooltipComponent,
        UserRendererComponent,
        SlideToggleRendererComponent,
        ValueGetterRendererComponent,
        LinkDialogRendererComponent,
        ClickableRendererComponent,
        PasswordCellEditorComponent,
        PenIconCellRendererComponent,
        DependenciesRendererComponent,
        SelectRowHeightButtonComponent,
        AddEllipsisDirective,
        DynamicPFieldCellEditorComponent
    ],
    imports: [
        CommonModule,
        PFieldModule,
        MatTooltipModule,
        PTooltipModule,
        PStatusSubLabelModule,
        PMultipleProgressBarModule,
        PLinkModule,
        PIconModule,
        PipeModule,
        TranslateModule,
        PActionButtonModule,
        MatMenuModule,
        FormsModule,
        PSlideToggleModule,
        PChipGroupModule,
        NgLetModule
    ],
    exports: [
        GroupRowRendererComponent,
        StatusSubLabelRendererComponent,
        BooleanIconRendererComponent,
        LinkableIconRendererComponent,
        LinkableRendererComponent,
        MultipleProgressBarRendererComponent,
        StatusRendererComponent,
        ColumnsPickerComponent,
        IconTextRendererComponent,
        IconTextEditorRendererComponent,
        PasswordCellEditorComponent,
        FullWidthCellRendererComponent,
        RoutingLinkRendererComponent,
        GridTooltipComponent,
        UserRendererComponent,
        SlideToggleRendererComponent,
        LinkDialogRendererComponent,
        ValueGetterRendererComponent,
        ClickableRendererComponent,
        PenIconCellRendererComponent,
        DependenciesRendererComponent,
        SelectRowHeightButtonComponent,
        AddEllipsisDirective,
        DynamicPFieldCellEditorComponent
    ]
})
export class GridUtilsModule {}
